import React, { FC } from 'react';

import { API_REPORT_TABLE } from '../../../shared/common/api/urls';
import MainLayout from '../../../shared/common/components/layouts/MainLayout';
import PageHead from '../../../shared/common/components/page-header/PageHeader';
import TableReport from '../../../shared/common/components/reports/table-report/TableReport';

const Users: FC = () => {

    const metrics = [
        { name: 'id GetCourse', dataKey: 'id' },
        { name: 'Дата и время регистрации', dataKey: 'reg_timestamp' },
        { name: 'Имя Фамилия', dataKey: 'name' },
        { name: 'Пол', dataKey: 'gender_name' },
        { name: 'Возраст', dataKey: 'age_name' },
        { name: 'E-mail', dataKey: 'email' },
        { name: 'Телефон', dataKey: 'phone' },
        { name: 'Дата рождения', dataKey: 'date_of_birth' },
        { name: 'utm_source регистрации', dataKey: 'utm_source_value' },
        { name: 'utm_medium регистрации', dataKey: 'utm_medium_value' },
        { name: 'utm_campaign регистрации', dataKey: 'utm_campaign_value' },
        { name: 'utm_content регистрации', dataKey: 'utm_content_value' },
        { name: 'utm_term регистрации', dataKey: 'utm_term_value' },
        { name: 'utm_group регистрации', dataKey: 'utm_group_value' },
        { name: 'Всего денег принес', dataKey: 'pay_sum' },
        { name: 'Давность регистрации', dataKey: 'reg_age' },
        { name: 'Страна', dataKey: 'country_name' },
        { name: 'Регион', dataKey: 'region_name' },
        { name: 'Город', dataKey: 'city_name' },
        { name: 'Часовой пояс', dataKey: 'utc_name' },
        { name: 'Телефонный код', dataKey: 'phone_code_name' },
        { name: 'Количество заказов', dataKey: 'order_count' },
    ];

    return (
        <MainLayout pageTitle="Пользователи">
            <div className="page-wrapper">
                <PageHead
                    title="Пользователи"
                    description={`
                        Отчёт, который позволяет посмотреть и выгрузить нужных пользователей онлайн-школы. Подробнее. 
                    `}
                />

                <div className="page-content">
                    <TableReport
                        apiUrl={API_REPORT_TABLE}
                        metrics={metrics}
                        filtersFilter={[ 'Пользователи' ]}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

export default Users;
